import { useFeatureFlags, useProductName } from '@chronosphereio/core';
import { useEffect } from 'react';

export function useDocumentTitle(title: string) {
  const productName = useProductName();
  useEffect(() => {
    document.title = `${title} - ${productName}`;
    return () => {
      document.title = productName;
    };
  }, [title, productName]);
}

const FAVICON_SVG_PATH = '/favicon.svg';

export function useFavicon() {
  const { enableNewLogoStubYear } = useFeatureFlags();
  useEffect(() => {
    if (!enableNewLogoStubYear) {
      return;
    }

    // checking if the favicon is already set to the SVG path
    const existing = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (existing?.href.endsWith(FAVICON_SVG_PATH)) {
      return;
    }

    // if the favicon is not set, create a new link element in the <head/> and set the href to the SVG path
    const link = existing ?? document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/svg+xml';
    link.href = FAVICON_SVG_PATH;
    if (!existing) {
      document.head.appendChild(link);
    }
  }, [enableNewLogoStubYear]);
}
